export const stateKey = 'nodeDefsIndex'
